import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  padding: 4px 8px;\n  max-width: 410px;\n\n  &:hover {\n    .tooltip {\n      display: flex;\n      opacity: 1;\n      visibility: visible;\n      transform: scale(1);\n      @media (max-width: 1200px) {\n        display: none;\n      }\n    }\n  }\n\n  .tooltip {\n    transition: all 0.3s ease;\n    transform: scale(0.8);\n    opacity: 0;\n    max-width: 410px;\n    position: absolute;\n    box-shadow: 6px 6px 20px 0px rgba(28, 31, 46, 0.12);\n    visibility: hidden;\n    top: -150px;\n    left: 0;\n    white-space: nowrap;\n    padding: 16px;\n    border-radius: 4px;\n    background: #ffff;\n\n    > div {\n      display: flex;\n      font-size: 14px;\n      color: #4f556b;\n      width: 400px;\n      word-wrap: break-word;\n      white-space: normal;\n      flex-wrap: wrap;\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 100%;\n      left: 42px;\n      margin-left: -8px;\n      border-width: 8px;\n      border-style: solid;\n      border-color: #ffff transparent transparent transparent;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  font-size: 14px;\n  display: flex;\n  position: relative;\n  align-items: center;\n\n  line-height: 22px;\n  border-radius: 3px;\n  border: 1px solid ",
        ";\n  //padding: 4px 8px;\n  height: 30px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  div {\n    color: ",
        ";\n  }\n\n  > p {\n    margin: 0;\n  }\n\n  i {\n    margin-left: 4px;\n    margin-bottom: 2px;\n  }\n\n  ",
        "\n  .chip-desc {\n    color: ",
        ";\n  }\n\n  .tooltip-desc {\n    color: ",
        ";\n    max-width: 410px;\n  }\n\n  :hover {\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  > b {\n    font-size: 16px;\n    font-weight: 600;\n    color: ",
        ";\n  }\n\n  div {\n    display: flex;\n    font-size: 14px;\n    color: ",
        ";\n    width: 380px;\n    word-wrap: break-word;\n  }\n\n  a {\n    color: ",
        ";\n    display: flex;\n    font-size: 12px;\n    align-items: center;\n    font-weight: 600;\n  }\n\n  .title {\n    font-size: 20px;\n    font-weight: 700;\n  }\n\n  .description {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n    margin-bottom: 8px;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import { ArrowRight, InfoCircle, QuestionCircle, Sizes } from "@/components/icon/IconList";
import Icon from "../icon/Icon";
import Link from "next/link";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { useModal } from "../../utils/overlay";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { AllowanceListType } from "./Handout/HandoutAllowanceChip";
// export const enum AllowanceListType {
// 	print = 'print',
// 	viewer = 'viewer',
// 	edit = 'edit',
// 	selling = 'slot',
// 	warningPrint = 'warningPrint',
// }
export const AllowanceListTypeWithString = {
    [AllowanceListType.print]: "프린터 출력 (PC, 100부)",
    [AllowanceListType.viewer]: "쏠북 뷰어로 열람",
    [AllowanceListType.selling]: "자료 저작 및 판매 가능",
    [AllowanceListType.warningPrint]: "프린트 출력 불가"
};
export const licenseAllowanceChipList = [
    {
        key: AllowanceListType.selling,
        color: "info",
        hasInfo: true,
        link: "https://solvookguide.oopy.io/guide/8",
        description: "라이선스 구매 시 쏠북이 제공하는 범위 내에서 제작, 편집, 판매 등의 활동을 진행할 수 있습니다. "
    },
    {
        key: AllowanceListType.warningPrint,
        color: "warning",
        hasInfo: false
    },
    {
        key: AllowanceListType.viewer,
        color: "info",
        hasInfo: true,
        link: "https://solvookguide.oopy.io/guide/5",
        description: "쏠북의 콘텐츠는 저작권 보호를 위해 쏠북 뷰어를 통해 열람할 수 있습니다. 실물 교재의 제공이나 인쇄는 지원되지 않습니다."
    }
];
export const workAllowanceChipList = [
    {
        key: AllowanceListType.selling,
        color: "info",
        hasInfo: true,
        link: "https://solvookguide.oopy.io/guide/8",
        description: "라이선스를 구매하게 되면 해당 권리를 계약(1년간)하게 되는 것으로 1회 구매당 총 100개의 저작자료를 쏠북에서 판매할 수 있습니다."
    }
];
export const handoutAllowanceChipList = [
    {
        key: AllowanceListType.viewer,
        color: "info",
        hasInfo: true,
        link: "https://solvookguide.oopy.io/guide/5",
        description: "쏠북의 모든 수업자료는 저작권 보호를 위해 쏠북의 뷰어 기능을 통해서만 열람할 수 있습니다. 프린트 출력은 뷰어의 출력하기 버튼을 통해 가능합니다. (PC에서만 가능)"
    },
    {
        key: AllowanceListType.print,
        color: "info",
        hasInfo: false
    }
];
export const AllowanceChip = (param)=>{
    let { chipItem , handleDrawer , productType  } = param;
    const theme = useTheme();
    const [isDrawerOpen, { open: openDrawer , close: closeDrawer  }] = useModal("drawer-modal");
    const { width  } = useWindowDimensions();
    const isMobile = width < 1200;
    const { key , color , link , hasInfo , description , linkTitle  } = chipItem;
    const title = AllowanceListTypeWithString[key];
    return /*#__PURE__*/ _jsx(AllowanceChipWrapper, {
        type: color,
        style: {
            pointerEvents: hasInfo ? "auto" : "none"
        },
        onMouseEnter: ()=>{
            if (isMobile) return;
            mixpanelEvent("Product Detail Page Marker hovered", {
                "Product Type": productType,
                "Marker Name": title,
                "Marker Btn Link": link
            });
        },
        onClick: ()=>{
            if (isMobile) {
                handleDrawer(chipItem);
                mixpanelEvent("Product Detail Page Marker hovered", {
                    "Product Type": productType,
                    "Marker Name": title,
                    "Marker Btn Link": link
                });
            }
        },
        children: /*#__PURE__*/ _jsx(TooltipWithIcon, {
            color: theme.new.colors.sol_gray_600,
            icon: hasInfo ? "info" : null,
            message: /*#__PURE__*/ _jsxs(TooltipWrapper, {
                children: [
                    /*#__PURE__*/ _jsx("b", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "description",
                        children: description
                    }),
                    link && /*#__PURE__*/ _jsxs(Link, {
                        href: link,
                        target: "_blank",
                        onClick: ()=>mixpanelEvent("Product Detail Page Marker Detail Clicked", {
                                "Product Type": productType,
                                "Marker Name": title,
                                "Marker Btn Link": link
                            }),
                        children: [
                            linkTitle || "자세히 보기",
                            /*#__PURE__*/ _jsx(Icon, {
                                icon: ArrowRight,
                                size: Sizes.xsmall,
                                color: theme.new.colors.indigo500
                            })
                        ]
                    })
                ]
            }),
            link: link,
            size: Sizes.small,
            children: title
        })
    });
};
const TooltipWithIcon = (param)=>{
    let { icon , message , color , size , children , link , isHover  } = param;
    const theme = useTheme();
    const isMobile = useWindowDimensions().width < 1200;
    const renderIcon = useCallback(()=>{
        switch(icon){
            case "question":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: QuestionCircle,
                    size: size,
                    color: color
                });
            case "info":
                return /*#__PURE__*/ _jsx(Icon, {
                    icon: InfoCircle,
                    size: size,
                    color: color
                });
            default:
                return null;
        }
    }, [
        icon
    ]);
    const tooltipRef = useRef(null);
    const [tooltipTop, setTooltipTop] = useState(150);
    const [isHovered, setIsHovered] = useState(false);
    useEffect(()=>{
        if (tooltipRef.current) {
            const tooltipHeight = tooltipRef.current.clientHeight + 16;
            setTooltipTop(tooltipHeight);
        }
    }, [
        message,
        isHovered
    ]);
    return /*#__PURE__*/ _jsxs(Tooltip, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                className: "tooltip",
                style: {
                    color: color,
                    top: -tooltipTop
                },
                ref: tooltipRef,
                children: /*#__PURE__*/ _jsx("div", {
                    children: message
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                children: children
            }),
            !!icon && /*#__PURE__*/ _jsx("span", {
                children: renderIcon()
            })
        ]
    });
};
// export default TooltipWithIcon
const Tooltip = styled.div.withConfig({
    componentId: "sc-591ba1b2-0"
})(_templateObject());
const AllowanceChipWrapper = styled.div.withConfig({
    componentId: "sc-591ba1b2-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.type === "warning" && "\n		div {\n			color: ".concat(props.theme.new.colors.sol_red_400, ";\n		}\n	\n	border: 1px solid ").concat(props.theme.new.colors.sol_red_100, ";\n	"), (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.sol_gray_0);
const TooltipWrapper = styled.div.withConfig({
    componentId: "sc-591ba1b2-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_800, (props)=>props.theme.new.colors.sol_gray_600, (props)=>props.theme.new.colors.indigo500);
